module.exports = __webpack_public_path__ + "images/c6149b5061b0615b298083173a677ba9-illu_newBox_MotionSensor.png";